import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../common/common.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { AuthService } from "src/app/components/authguard/auth.service";
import { Subject, Subscription } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class IdleService {
  private idleTimeout: any;
  private idleTimeLimit = 30 * 60 * 1000; // 30 minutes
  private idleSubject = new Subject<void>();
  private activitySubscription: Subscription;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private auth: AuthService,
    private AuthenticationService: AuthenticationService
  ) {
    this.activitySubscription = new Subscription();

    this.startWatching();
  }

  private startWatching() {
    console.log("start watching");
    this.resetTimer();

    // Track user activity
    this.activitySubscription = new Subscription();
    const events = ["click", "mousemove", "keypress", "touchstart"];
    events.forEach((event) => {
      window.addEventListener(event, () => this.resetTimer());
    });
  }

  private resetTimer() {
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(() => {
      this.onIdle();
    }, this.idleTimeLimit);
  }

  private onIdle() {
    if (!this.auth.isLoggedIn()) return; // Check if the user is still logged in
    // Call the logout logging service
    this.logoutOnIdle();
  }

  public stopWatching() {
    clearTimeout(this.idleTimeout);
    this.activitySubscription.unsubscribe();
  }

  logoutOnIdle() {
    let  customerActionLogsId = localStorage.getItem("customerActionLogsId");
    this.commonService
      .logout(customerActionLogsId)
      .subscribe((response: any) => {
        this.AuthenticationService.logoutUser();
        localStorage.clear();
        this.router.navigate(["/login"]);
      });
  }
}
